// pages/AccessRequestedPage.jsx
import { useSearchParams, Link } from 'react-router-dom';

export default function AccessRequestedPage() {
  const [searchParams] = useSearchParams();
  const contractNumber = searchParams.get('contract');

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        {/* Success Icon */}
        <div className="mx-auto w-20 h-20 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center mb-6 shadow-lg">
          <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-3">
          Cerere Trimisă!
        </h1>
        
        <p className="text-lg text-gray-600 mb-6">
          Un nou link de acces pentru contractul <br/>
          <strong className="text-indigo-600">#{contractNumber}</strong><br/>
          a fost trimis pe email.
        </p>
        
        {/* Info Box */}
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-xl p-5 mb-6">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0">
              <svg className="w-6 h-6 text-blue-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <div className="text-left">
              <p className="font-semibold text-blue-900 mb-1">Verificați inbox-ul</p>
              <p className="text-sm text-blue-700">
                Veți primi în câteva momente un email cu noul link și cod de acces.
              </p>
            </div>
          </div>
        </div>
        
        {/* Spam Notice */}
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-6">
          <p className="text-xs text-yellow-800">
            💡 <strong>Sfat:</strong> Dacă nu găsiți emailul în inbox, verificați și folderul de spam/junk.
          </p>
        </div>
        
        {/* Timeline */}
        <div className="text-left bg-gray-50 rounded-lg p-4 mb-6">
          <p className="text-sm font-semibold text-gray-700 mb-3">Ce urmează:</p>
          <div className="space-y-2">
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <span className="flex-shrink-0 w-5 h-5 bg-green-500 text-white rounded-full flex items-center justify-center text-xs font-bold">1</span>
              <span>Primiți email (1-2 minute)</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <span className="flex-shrink-0 w-5 h-5 bg-blue-500 text-white rounded-full flex items-center justify-center text-xs font-bold">2</span>
              <span>Deschideți linkul din email</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <span className="flex-shrink-0 w-5 h-5 bg-indigo-500 text-white rounded-full flex items-center justify-center text-xs font-bold">3</span>
              <span>Introduceți codul de acces</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <span className="flex-shrink-0 w-5 h-5 bg-purple-500 text-white rounded-full flex items-center justify-center text-xs font-bold">4</span>
              <span>Semnați contractul</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}